// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rBK2","controls":"styles_controls__1YUlW","charLimit":"styles_charLimit__dV_vl","input":"styles_input__1-sew","send":"styles_send__3N_iy"};